module.exports = __webpack_public_path__ + "img/visa.afc3b975.png";